<template>
  <Teleport to="body">
    <div v-show="modalActive" class="modal-bg">
      <div class="modal" :class="size">
        <div class="modal-header">
          <h3>Preview Article</h3>
          <i @click="$emit('close')" class="close-icon fa-solid fa-xmark"></i>
        </div>
        <div class="modal-content">
          <slot></slot>
        </div>
      </div>
    </div>
  </Teleport>
</template>
<script>
export default {
  props: {
    modalActive: {
      type: Boolean,
      require: false,
      default: false
    },
    size: {
      type: String,
      require: false,
      default: 'default'
    }
  },
  emits: ['close']
}
</script>
<style scoped>
  .modal-bg {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    background: rgba(0, 0, 0, 0.7);
    z-index: 10;
  }

  .modal {
    padding: 16px;
    background: #fff;
    width: 700px;
    align-self: center;
    border-radius: 12px;
  }

  .modal-header {
    height: 30px;
    border-bottom: 2px solid #d9d9d9;
    display: flex;
    justify-content: space-between;
    padding-bottom: 5px;
  }

  .modal-content {
    height: 80vh; /* Đặt max-height */
    overflow-y: auto;
    overflow-x: hidden;
    margin-top: 15px;
  }

  .small {
    width: 300px;
  }

  .default {
    width: 600px;
  }

  .large {
    width: 1000px;
  }

  .close-icon {
    caret-color: transparent;
    cursor: pointer;
    transition: color 0.3s ease-out;
  }

  .close-icon:hover {
    color: red;
  }
</style>
